import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CreatorsLayout } from '../../components/layouts/CreatorsLayout';

/**
 * Creators section layout route
 * Accessible to all authenticated users - anyone can explore creator tools
 * without needing to commit to selling
 */
export const Route = createFileRoute('/_authenticated/creators')({
  component: CreatorsRoute,
});

function CreatorsRoute() {
  return (
    <CreatorsLayout>
      <Outlet />
    </CreatorsLayout>
  );
}
